import { Base } from '@studiometa/js-toolkit';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

gsap.registerPlugin(ScrollTrigger);

/**
 *
 */
export default class Hero extends Base {
  static config = {
    name: 'Hero',
    refs: ['media'],
  };

  /**
   *
   */
  mounted() {
    gsap.to(this.$refs.media, {
      y: 100,
      scrollTrigger: {
        trigger: this.$el,
        start: 'top top',
        end: 'bottom top',
        scrub: true,
        invalidateOnRefresh: true,
      },
    });
  }
}
